<template>
  <div :class="['app--wrapper default', isWordBreak]">
    <NavigationDesktop
      :navbarColor="navbarColor"
      :is-transparent="navTransparent"
      :buttons-color="navTextColor"
    />
    <NavigationMobile
      :navbarColor="navbarColor"
      :is-transparent="navTransparent"
      :buttons-color="navTextColor"
    />
    <main id="main-content" tabindex="-1">
      <slot />
    </main>
    <div id="notification-outlet" />
    <LazyFooterCustom :footerColor="footerColor" />
  </div>
</template>

<script setup lang="ts">
interface Props {
  navbarColor?: string
  footerColor?: string
  navTransparent?: boolean
  navTextColor?: '#000033' | '#fff'
}
defineProps<Props>()

const { locale } = useI18n()
const isWordBreak = computed(() => (locale.value === 'de' ? 'break-word' : ''))
useSetScreenValues()
</script>
